<template>
  <v-container>
    <h1 class="display-1 mt-4 mb-4">Grupos de Clientes</h1>
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-space-around>
        <v-flex xs12 sm4 lg3>
          <v-card color="cyan" dark>
            <v-card-title>
              <h3 class="title font-weight-light">Clientes Promotores</h3>
            </v-card-title>
            <v-card-text class="headline font-weight-bold text-xs-center py-3">
              {{ numPromoters }}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 lg3>
          <v-card dark color="blue">
            <v-card-title>
              <h3 class="title font-weight-light">Clientes Detratores</h3>
            </v-card-title>
            <v-card-text class="headline font-weight-bold text-xs-center py-3">
              {{ numDetratores }}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4 lg3>
          <v-card dark color="indigo">
            <v-card-title>
              <h3 class="title font-weight-light">Clientes Imparciais</h3>
            </v-card-title>
            <v-card-text class="headline font-weight-bold text-xs-center py-3">
              {{ numImparciais }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <h1 class="display-1 my-5">Todos os Clientes</h1>
    <v-data-table
      :headers="headers"
      :items="clientes"
      class="elevation-1"
      hide-actions
      sort-icon="fa fa-arrow-up"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.idcliente }}</td>
          <td>{{ props.item.nmcliente ? props.item.nmcliente : "--" }}</td>
          <td>{{ props.item.telefone ? props.item.telefone : "--" }}</td>
          <td>{{ props.item.email ? props.item.email : "--" }}</td>
          <td v-if="isAdmin" class="text-xs-right">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small>fa fa-ellipsis-v</v-icon>
                </v-btn>
              </template>
              <v-list one-line>
                <v-list-tile @click="editCliente(props.item)">
                  <v-list-tile-action>
                    <v-icon small>fa fa-edit</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="body-1">Editar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="deleteCliente(props.item.idcliente)">
                  <v-list-tile-action>
                    <v-icon small>fa fa-trash</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title class="body-1">Deletar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
          <td v-else>
            --
          </td>
        </tr>
      </template>
    </v-data-table>
    <app-form-cliente
      v-if="isAdmin"
      v-model="dialog"
      :item="cliente"
      @load-clientes="loadClientes"
    ></app-form-cliente>
  </v-container>
</template>
<script>
import axios from "axios";
import FormCliente from "@/components/FormCliente";
import { mapGetters } from "vuex";
export default {
  name: "Clientes",
  data() {
    return {
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "idcliente"
        },
        { text: "Nome", value: "nmcliente" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Opções", value: "idcliente", sortable: false }
      ],
      numPromoters: 0,
      numDetratores: 0,
      numImparciais: 0,
      clientes: [],
      cliente: null,
      dialog: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"])
  },
  created() {
    this.loadClientes();
  },
  methods: {
    loadClientes() {
      const idempresa = this.$store.getters.user.idempresa;
      axios
        .get(`/cliente/getByEmpresaId/${idempresa}`)
        .then(res => (this.clientes = res.data));
    },
    editCliente(item) {
      this.dialog = true;
      this.cliente = { ...item };
    },
    deleteCliente(id) {
      this.$dialog
        .show({
          title: "Deseja realmente apagar este cliente?",
          text:
            "Esta ação não pode ser desfeita. Respostas associadas a este cliente também serão deletados permanentemente."
        })
        .then(() => {
          axios.delete(`/cliente/delete/${id}`).then(() => {
            this.loadClientes();
          });
        });
    }
  },
  components: {
    appFormCliente: FormCliente
  }
};
</script>
